import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@vibrent/electryon';

/**
 * NotFound
 * @extends Component
 */
const NotFound = (props) => {
  const { t } = useTranslation();
  const [countDown, setCountDown] = useState(10);

  const updateCountDown = () => {
    setCountDown(countDown - 1);
  };

  const goBack = () => {
    props.history.go(-1);
  };

  const goToHomePage = () => {
    props.history.push('/');
  };

  // The page-not-found content (and its auto-redirect to home) should only
  // appear once modules have finished loading. While they are still loading we
  // render a spinner instead (and never run the countdown) so a deep-link
  // refresh isn't bounced to the landing page before its route registers.
  const showNotFoundMessage = props.numberModuleWillBeLoad === 0;

  useEffect(() => {
    if (!showNotFoundMessage) {
      return undefined;
    }
    if (countDown === 0) {
      goToHomePage();
      return undefined;
    }
    const timer = setTimeout(updateCountDown, 1000);
    return () => clearTimeout(timer);
  }, [countDown, showNotFoundMessage]);

  if (showNotFoundMessage) {
    return (
      <div className="text-center">
        <h1>{t("We're sorry")}</h1>
        <h2>{t('The page you are looking for cannot be found.')}</h2>
        <p>
          {t('automaticallyRedirect')}{' '}
          <a
            tabIndex="0"
            role="button"
            onClick={goToHomePage}
          >
            {t('home')}{' '}
          </a>
          {t('page in')}{' '}
          <span id="countDown" >
            {countDown}
          </span>
          {' '}{t('seconds.')}
          <br />
          {t('Or')}{' '}
          <a
            className="testlink"
            tabIndex="0"
            role="button"
            onClick={goBack}
          >
            {t('click here')}{' '}
          </a>
          {' '}{t('to go back to the previous page.')}
        </p>
      </div>
    );
  }

  return (<div className="text-center">
    <Spinner radius={120} color={'#0099db'} stroke={2} />
  </div>);
};

const mapStateToProps = state => ({
  numberModuleWillBeLoad: state.ModuleLoader.get('numberModuleWillBeLoad'),
});

NotFound.propTypes = {
  history: PropTypes.shape({
    go: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  numberModuleWillBeLoad: PropTypes.number,
};

NotFound.defaultProps = {
  numberModuleWillBeLoad: undefined,
};

export default connect(
  mapStateToProps,
  null,
)(NotFound);

export const NotFoundComponent = NotFound;
